import React from "react";
import clsx from "clsx";
import ChartWidget from "../ChartWidget/ChartWidget";

class UserDashboardColumn extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    var columnClasses = clsx({
      column: true,
      "col-md-1": this.props.size == 1,
      "col-md-2": this.props.size == 2,
      "col-md-3": this.props.size == 3,
      "col-md-4": this.props.size == 4,
      "col-md-5": this.props.size == 5,
      "col-md-6": this.props.size == 6,
      "col-md-7": this.props.size == 7,
      "col-md-8": this.props.size == 8,
      "col-md-9": this.props.size == 9,
      "col-md-10": this.props.size == 10,
      "col-md-11": this.props.size == 11,
      "col-md-12": this.props.size == 12,
    });

    return (
      <div className={columnClasses}>
        {this.props.content_type === "text" && this.renderText()}
        {this.props.content_type === "chart" && this.renderChart()}
        {this.props.content_type === "widget" && this.renderWidget()}
      </div>
    );
  }

  renderText() {
    return <div dangerouslySetInnerHTML={{ __html: this.props.content }}></div>;
  }

  renderChart() {
    return <ChartWidget {...this.props} />;
  }

  renderWidget() {
    // console.log("renderWidget", this.props);
    
    var WidgetComponent = this.props.widgets[this.props.widget_id];

    return <WidgetComponent {...this.props} />;
  }
}

export default UserDashboardColumn;
